import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import NumberFormat from 'components/NumberFormat'
import DayTime from 'components/DayTime'
import TimeAgo from 'components/TimeAgo'

export default class Cell extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    format: PropTypes.oneOf([
      'number',
      'decimal',
      'decimalDouble',
      'signed-number',
      'currency',
      'percent',
      'signed-percent',
      'signed-decimalDouble',
      'doublePercent',
      'date',
      'datetime',
      'timeago'
    ]),
    grow: PropTypes.bool,
    width: PropTypes.string,
    align: PropTypes.oneOf(['left', 'right', 'center']),
    emptyPlaceholder: PropTypes.string,
    onClick: PropTypes.func
  }

  render() {
    const {
      className,
      format,
      grow,
      align,
      width,
      children,
      onClick,
      emptyPlaceholder
    } = this.props
    const classNames = classnames(
      'table-cell',
      {
        [`is-${format}`]: !!format,
        [`is-align-${align}`]: !!align,
        'is-grow': grow || !width
      },
      className
    )
    const style = width
      ? {
          width
        }
      : null

    return (
      <div className={classNames} style={style} onClick={onClick}>
        {children ? this.renderValue() : emptyPlaceholder}
      </div>
    )
  }

  renderValue() {
    const {children, format} = this.props
    if (
      format === 'number' ||
      format === 'decimal' ||
      format === 'decimalDouble' ||
      format === 'currency' ||
      format === 'percent' ||
      format === 'signed-number' ||
      format === 'signed-percent' ||
      format === 'signed-decimalDouble' ||
      format === 'doublePercent'
    ) {
      return <NumberFormat value={children} format={format} />
    } else if (format === 'date') {
      return <DayTime date={children} />
    } else if (format === 'datetime') {
      return <DayTime date={children} time />
    } else if (format === 'timeago') {
      return <TimeAgo date={children} />
    } else {
      return children
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/Table/Cell.js